import _ from 'lodash';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dmcaTranslations from './dmca';
import gdprTranslations from './gdpr';
import surveyTranslations from './survey';
import sweepsTranslations from './sweeps';

Vue.use(VueI18n);

const messages = _.merge({}, gdprTranslations, dmcaTranslations, surveyTranslations, sweepsTranslations);

const i18n = new VueI18n({
  locale: 'en-us', // set locale
  messages, // set locale messages
});

export default i18n;
